import { gsap } from 'gsap';

const SELECTOR = {
  CURSOR: document.querySelector('[data-cursor]'),
  CHASER: document.querySelector('[data-chaser]'),
  TARGETS: [...document.querySelectorAll('a')],
}

const CLASSES = {
  ACTIVE: 'is-active'
}

export default class Cursor {
  constructor() {
    if(!SELECTOR.CURSOR) return;
    
    let delay = 10;
    let cursorPosX = 0;
    let cursorPosY = 0;
    let chaserPosX = 0;
    let chaserPosY = 0;
    
    gsap.to({}, {
      duration: .01,
      repeat: -1,
    
      onRepeat: function() {
        chaserPosX += (cursorPosX - chaserPosX) / delay;
        chaserPosY += (cursorPosY - chaserPosY) / delay;
        
        gsap.set(SELECTOR.CURSOR, {
          css: {
            left: cursorPosX - (SELECTOR.CURSOR.clientWidth / 2),
            top: cursorPosY - (SELECTOR.CURSOR.clientWidth / 2)
          }
        });
    
        gsap.set(SELECTOR.CHASER, {
          css: {
            left: chaserPosX - (SELECTOR.CHASER.clientWidth / 2),
            top: chaserPosY - (SELECTOR.CHASER.clientWidth / 2)
          }
        });
      }
    });
    
    document.onmousemove = function(event) {
      cursorPosX = event.clientX;
      cursorPosY = event.clientY;
    };
    
    SELECTOR.TARGETS.forEach(_target => {
      _target.onmouseover = function() {
        SELECTOR.CURSOR.classList.add(CLASSES.ACTIVE);
        SELECTOR.CHASER.classList.add(CLASSES.ACTIVE);
      };
    })
    
    SELECTOR.TARGETS.forEach(_target => {
      _target.onmouseout = function() {
        SELECTOR.CURSOR.classList.remove(CLASSES.ACTIVE);
        SELECTOR.CHASER.classList.remove(CLASSES.ACTIVE);
      };
    })

  }
}